export interface IApiClient {
  get: <T>(url: string, config?: ng.IRequestShortcutConfig) => ng.IPromise<T>;
  post: <T>(url: string, data?: any, config?: ng.IRequestShortcutConfig) => ng.IPromise<T>;
}

export class ApiClient implements IApiClient {
  public static $inject = ["$http", "$q", "ngToast", "$state"];

  constructor(
    private $http: ng.IHttpService,
    private $q: ng.IQService,
    private ngToast: any,
    private $state: angular.ui.IStateService,
  ) {}

  private getResponseData = (response: any): any => {
    return response.data;
  };

  private createErrorHandler = (config: ng.IRequestShortcutConfig): any => {
    config = config || {};

    var exceptionFunction = (response: ng.IHttpPromiseCallbackArg<any>) => {
      var errorCode = response.headers("AIOperationId") || null;

      var message = "<p>Error: Status Code " + response.status + "</p>";

      if (errorCode) message = message + "<br/><br/><p>Error Code: " + errorCode + "</p>";

      this.ngToast.create({ content: message, dismissButton: true, timeout: 4000, className: "danger" });
      if (response.status === 401) {
        this.$state.go("login", { statename: this.$state.current.name });
      }
      return this.$q.reject(response);
    };
    return exceptionFunction;
  };

  public get = <T>(url: string, config?: ng.IRequestShortcutConfig): ng.IPromise<T> => {
    config = config || {};
    var call = () => {
      return this.$http.get(this.buildUrl(url), config).then(this.getResponseData, this.createErrorHandler(config));
    };

    return call();
  };

  public post = <T>(url: string, data?: any, config?: ng.IRequestShortcutConfig): ng.IPromise<T> => {
    data = data || {};
    config = config || {};

    var call = () => {
      return this.$http
        .post(this.buildUrl(url), data, config)
        .then(this.getResponseData, this.createErrorHandler(config));
    };

    return call();
  };

  private buildUrl = (url: string): string => {
    if (!url.startsWith("/")) url = `/${url}`;

    if (!url.toLowerCase().startsWith("/api")) url = `/api${url}`;

    return url;
  };
}
